<template>
  <div class="container">
    <div v-if="pageLoading && !dataReady" class="page-loading">
      <div class="loader-card">
        <div class="loader-core"></div>
        <div class="loader-title">数据看板加载中</div>
        <div class="loader-subtitle">正在同步 OPPO / VIVO / 腾讯 / 快手媒体数据...</div>
      </div>
    </div>

    <div v-else class="dashboard">
      <div v-if="allLoading" class="refresh-tip">
        <i class="el-icon-loading"></i>
        全量数据刷新中，请稍候...
      </div>

      <div class="page-head">
        <div>
          <div class="page-kicker">MEDIA COST DASHBOARD</div>
          <div class="page-title">外部组媒体消耗看板</div>
          <div class="page-desc">OPPO / VIVO / 腾讯 / 快手外部媒体消耗监控</div>
        </div>
        <el-button class="refresh-btn" type="primary" size="mini" icon="el-icon-refresh" @click="fetchAllData" :loading="allLoading">
          刷新数据
        </el-button>
      </div>

      <!-- 全平台总汇总 -->
      <div class="total-summary">
        <div class="total-card total-today">
          <div class="total-icon">
            <i class="el-icon-trend-charts"></i>
          </div>
          <div class="total-content">
            <div class="total-label">全平台今日总消耗</div>
            <div class="total-value">{{ allPlatformToday | currencyYuan }}</div>
          </div>
          <div class="total-detail">OPPO + VIVO + 腾讯 + 快手 + 趣头条 + WiFi</div>
        </div>
        <div class="total-card total-yesterday">
          <div class="total-icon">
            <i class="el-icon-time"></i>
          </div>
          <div class="total-content">
            <div class="total-label">全平台昨日总消耗</div>
            <div class="total-value">{{ allPlatformYesterday | currencyYuan }}</div>
          </div>
          <div class="total-detail">OPPO + VIVO + 腾讯 + 快手 + 趣头条 + WiFi</div>
        </div>
      </div>

      <!-- 各平台汇总 -->
      <div class="summary">
        <div class="summary-row">
          <div class="card oppo">
            <div class="card-label">OPPO今日消耗</div>
            <div class="value">{{ totalCost | currency }}</div>
          </div>
          <div class="card oppo-soft">
            <div class="card-label">OPPO昨日消耗</div>
            <div class="value">{{ totalYesterdayCost | currency }}</div>
          </div>
        </div>
        <div class="summary-row">
          <div class="card vivo">
            <div class="card-label">VIVO今日消耗</div>
            <div class="value">{{ vivoTotal | currencyYuan }}</div>
          </div>
          <div class="card vivo-soft">
            <div class="card-label">VIVO昨日消耗</div>
            <div class="value">{{ vivoTotalYesterday | currencyYuan }}</div>
          </div>
        </div>
        <div class="summary-row">
          <div class="card tencent">
            <div class="card-label">腾讯今日消耗</div>
            <div class="value">{{ tencentTotal | currencyYuan }}</div>
          </div>
          <div class="card tencent-soft">
            <div class="card-label">腾讯昨日消耗</div>
            <div class="value">{{ tencentTotalYesterday | currencyYuan }}</div>
          </div>
        </div>
        <div class="summary-row">
          <div class="card kuaishou">
            <div class="card-label">快手今日消耗</div>
            <div class="value">{{ kuaishouTotal | currencyYuan }}</div>
          </div>
          <div class="card kuaishou-soft">
            <div class="card-label">快手昨日消耗</div>
            <div class="value">{{ kuaishouTotalYesterday | currencyYuan }}</div>
          </div>
        </div>
        <div class="summary-row">
          <div class="card qtt">
            <div class="card-label">趣头条今日消耗</div>
            <div class="value">{{ qttTotal | currencyYuan }}</div>
          </div>
          <div class="card qtt-soft">
            <div class="card-label">趣头条昨日消耗</div>
            <div class="value">{{ qttTotalYesterday | currencyYuan }}</div>
          </div>
        </div>
        <div class="summary-row">
          <div class="card wifi">
            <div class="card-label">WiFi今日消耗</div>
            <div class="value">{{ wifiTotal | currencyYuan }}</div>
          </div>
          <div class="card wifi-soft">
            <div class="card-label">WiFi昨日消耗</div>
            <div class="value">{{ wifiTotalYesterday | currencyYuan }}</div>
          </div>
        </div>
      </div>

      <!-- VIVO数据 -->
      <div class="card-item vivo-section" v-if="vivoData.length > 0">
        <div class="header">
          <div>
            <div class="title">VIVO消费数据</div>
            <div class="title-sub">指定主体今日 / 昨日消耗</div>
          </div>
          <div class="stats">
            总消费 {{ vivoTotal | currencyYuan }}
          </div>
        </div>
        <div class="table vivo-table">
          <div class="row header-row">
            <div>账户名称</div>
            <div>区域</div>
            <div>今日消费</div>
            <div>昨日消费</div>
          </div>
          <div class="row" v-for="item in vivoData" :key="item.advName">
            <div class="name">{{ item.advName }}</div>
            <div>{{ item.region }}</div>
            <div>{{ item.todayCost | currencyYuan }}</div>
            <div>{{ item.yesterdayCost | currencyYuan }}</div>
          </div>
        </div>
      </div>
      <div v-if="!vivoLoading && vivoData.length === 0" class="loading">暂无VIVO数据</div>

      <!-- 腾讯数据 -->
      <div class="card-item tencent-section" v-if="tencentData.length > 0">
        <div class="header">
          <div>
            <div class="title">腾讯消费数据</div>
            <div class="title-sub">维沃 + 淘宝，按主体聚合今日 / 昨日消耗</div>
          </div>
          <div class="stats">
            总消费 {{ tencentTotal | currencyYuan }}
          </div>
        </div>
        <div class="table tencent-table">
          <div class="row header-row">
            <div>主体名称</div>
            <div>今日消费</div>
            <div>昨日消费</div>
          </div>
          <div class="row" v-for="item in tencentData" :key="item.id || item.name">
            <div class="name">{{ item.name }}</div>
            <div>{{ item.todayCost | currencyYuan }}</div>
            <div>{{ item.yesterdayCost | currencyYuan }}</div>
          </div>
        </div>
      </div>
      <div v-if="!tencentLoading && tencentData.length === 0" class="loading">暂无腾讯数据</div>

      <!-- 快手数据 -->
      <div class="card-item kuaishou-section" v-if="kuaishouData.length > 0">
        <div class="header">
          <div>
            <div class="title">快手消费数据</div>
            <div class="title-sub">快手账户今日 / 昨日消耗</div>
          </div>
          <div class="stats">
            总消费 {{ kuaishouTotal | currencyYuan }}
          </div>
        </div>
        <div class="table kuaishou-table">
          <div class="row header-row">
            <div>账户ID</div>
            <div>账户名称</div>
            <div>今日消费</div>
            <div>昨日消费</div>
          </div>
          <div class="row" v-for="item in kuaishouData" :key="item.accountId">
            <div>{{ item.accountId }}</div>
            <div class="name">{{ item.accountName }}</div>
            <div>{{ item.todayCost | currencyYuan }}</div>
            <div>{{ item.yesterdayCost | currencyYuan }}</div>
          </div>
        </div>
      </div>
      <div v-if="!kuaishouLoading && kuaishouData.length === 0" class="loading">暂无快手数据</div>

      <!-- 趣头条数据 -->
      <div class="card-item qtt-section" v-if="qttData.length > 0">
        <div class="header">
          <div>
            <div class="title">趣头条消费数据</div>
            <div class="title-sub">按客户汇总今日 / 昨日消耗</div>
          </div>
          <div class="stats">
            总消费 {{ qttTotal | currencyYuan }}
          </div>
        </div>
        <div v-if="qttPartial" class="qtt-tip">
          <i class="el-icon-warning-outline"></i>
          部分客户取数失败，总消费仅统计成功客户
        </div>
        <div class="table qtt-table">
          <div class="row header-row">
            <div>代理商名称</div>
            <div>客户名称</div>
            <div>今日消费</div>
            <div>昨日消费</div>
          </div>
          <div class="row" v-for="item in qttData" :key="item.customerName" :class="{ 'qtt-failed': item.success === false }">
            <div class="name">{{ item.agentName || '-' }}</div>
            <div class="name">{{ item.customerName }}</div>
            <div>{{ formatQttCost(item.todayCost) }}</div>
            <div>{{ formatQttCost(item.yesterdayCost) }}</div>
          </div>
        </div>
        <div v-if="qttErrorMsg" class="qtt-error">{{ qttErrorMsg }}</div>
      </div>
      <div v-if="!qttLoading && qttData.length === 0 && qttError" class="qtt-error">{{ qttError }}</div>
      <div v-else-if="!qttLoading && qttData.length === 0" class="loading">暂无趣头条数据</div>

      <!-- WiFi数据 -->
      <div class="card-item wifi-section" v-if="wifiData.length > 0">
        <div class="header">
          <div>
            <div class="title">WiFi消费数据</div>
            <div class="title-sub">按账号汇总今日 / 昨日消耗</div>
          </div>
          <div class="stats">
            总消费 {{ wifiTotal | currencyYuan }}
          </div>
        </div>
        <div v-if="wifiPartial" class="wifi-tip">
          <i class="el-icon-warning-outline"></i>
          部分账号取数失败，总消费仅统计成功账号
        </div>
        <div class="table wifi-table">
          <div class="row header-row">
            <div>账号名称</div>
            <div>今日消费</div>
            <div>昨日消费</div>
          </div>
          <div class="row" v-for="item in wifiData" :key="item.accountId" :class="{ 'wifi-failed': item.success === false }">
            <div class="name">{{ item.accountName }}</div>
            <div>{{ formatWifiCost(item.todayCost) }}</div>
            <div>{{ formatWifiCost(item.yesterdayCost) }}</div>
          </div>
        </div>
        <div v-if="wifiErrorMsg" class="wifi-error">{{ wifiErrorMsg }}</div>
      </div>
      <div v-if="!wifiLoading && wifiData.length === 0 && wifiError" class="wifi-error">{{ wifiError }}</div>
      <div v-else-if="!wifiLoading && wifiData.length === 0" class="loading">暂无WiFi数据</div>

      <!-- 表头 -->
      <div class="table header-fixed">
        <div class="row header-row">
          <div>oppo端口名称</div>
          <div @click="changeSort('todayCashCost')">今日 ⬍</div>
          <div @click="changeSort('yesterdayCost')">昨日 ⬍</div>
          <div @click="changeSort('cashBal')">余额 ⬍</div>
        </div>
      </div>

      <!-- 列表 -->
      <div v-if="loading" class="loading">OPPO数据加载中...</div>
      <div v-else-if="groupedList.length === 0" class="loading">暂无OPPO消耗数据</div>
      <div v-else>
        <div v-for="group in groupedList" :key="group.recordAccount" class="card-item oppo-section">

          <!-- 分组 -->
          <div class="header">
            <div>
              <div class="title">{{ group.recordAccount }}</div>
            </div>
            <div class="stats">
              今 {{ group.today | currency }} / 昨 {{ group.yesterday | currency }}
            </div>
          </div>

          <!-- 数据 -->
          <div class="table">
            <div class="row" v-for="item in group.items" :key="item.ownerName">
              <div class="name">{{ item.ownerName }}</div>
              <div>{{ item.todayCashCost | currency }}</div>
              <div>{{ item.yesterdayCost | currency }}</div>
              <div :class="{ warn: item.cashBal < 10000 }">
                {{ item.cashBal | currency }}
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

// 腾讯广告主体消耗查询接口：固定返回维沃 + 淘宝两主体，一次请求同时给出今日 / 昨日
const TENCENT_QUERY_URL = 'https://ads-cost-api.app.workbuddy.host/api/cost'
const TENCENT_QUERY_TOKEN = 'b322ccb2eba0db5c27157f42'

// WiFi 账号静态汇总：不传 accountIds 即返回全部账号，spend=今日、spendY=昨日
// 注意接口返回的金额单位是分（文档写元是错的），展示前要除以 100
const WIFI_STATIC_URL = 'https://wcry.zjwec.cn/v2/media/aiyituo/report/data-static'

export default {
  data() {
    return {
      rawData: [],
      groupedList: [],
      loading: false,
      allLoading: false,
      pageLoading: true,
      dataReady: false,
      totalCost: 0,
      totalYesterdayCost: 0,
      sortKey: 'todayCashCost',
      sortOrder: 'desc',
      // VIVO数据相关
      vivoData: [],
      vivoLoading: false,
      vivoCookies: [],
      vivoTotal: 0,
      vivoTotalYesterday: 0,
      // 腾讯数据相关
      tencentData: [],
      tencentLoading: false,
      tencentTotal: 0,
      tencentTotalYesterday: 0,
      tencentError: '',
      // 快手数据相关
      kuaishouData: [],
      kuaishouLoading: false,
      kuaishouTotal: 0,
      kuaishouTotalYesterday: 0,
      // 趣头条数据相关
      qttData: [],
      qttLoading: false,
      qttTotal: 0,
      qttTotalYesterday: 0,
      qttPartial: false,
      qttError: '',
      // WiFi 数据相关
      wifiData: [],
      wifiLoading: false,
      wifiTotal: 0,
      wifiTotalYesterday: 0,
      wifiPartial: false,
      wifiError: ''
    }
  },

  filters: {
    currency(v) {
      if (!v) return '0.00'
      return (v / 100).toFixed(2)
    },
    currencyYuan(v) {
      if (v == null || v === '') return '0.00'
      const num = Number(v)
      if (isNaN(num)) return '0.00'
      return num.toFixed(2)
    }
  },

  computed: {
    // 全平台今日总消耗（OPPO需要除以100转为元）
    allPlatformToday() {
      const oppoCost = (this.totalCost || 0) / 100
      const vivoCost = Number(this.vivoTotal) || 0
      const tencentCost = Number(this.tencentTotal) || 0
      const kuaishouCost = Number(this.kuaishouTotal) || 0
      const qttCost = Number(this.qttTotal) || 0
      const wifiCost = Number(this.wifiTotal) || 0
      return oppoCost + vivoCost + tencentCost + kuaishouCost + qttCost + wifiCost
    },
    // 全平台昨日总消耗
    allPlatformYesterday() {
      const oppoCost = (this.totalYesterdayCost || 0) / 100
      const vivoCost = Number(this.vivoTotalYesterday) || 0
      const tencentCost = Number(this.tencentTotalYesterday) || 0
      const kuaishouCost = Number(this.kuaishouTotalYesterday) || 0
      const qttCost = Number(this.qttTotalYesterday) || 0
      const wifiCost = Number(this.wifiTotalYesterday) || 0
      return oppoCost + vivoCost + tencentCost + kuaishouCost + qttCost + wifiCost
    },
    // 趣头条取数失败的客户明细文案
    qttErrorMsg() {
      const failed = this.qttData.filter(item => item.success === false)
      if (failed.length === 0) {
        return ''
      }
      return failed.map(item => `${item.customerName}：${item.errorMsg || '取数失败'}`).join('；')
    },
    // WiFi 取数失败的账号明细文案
    wifiErrorMsg() {
      const failed = this.wifiData.filter(item => item.success === false)
      if (failed.length === 0) {
        return ''
      }
      return failed.map(item => `${item.accountName}：${item.errorMsg || '取数失败'}`).join('；')
    }
  },

  created() {
    this.fetchAllData()
  },

  methods: {
    fetchData(showMessage = true) {
      this.loading = true
      return axios.get('https://wcry.zjwec.cn/operation/oppo/project/account/queryMktData', {
        params: { groupName: '张杰组' }
      }).then(res => {
        const data = res.data.data || []
        this.rawData = data
        this.processData()
        this.calc()
        if (showMessage) {
          this.$message.success('OPPO数据刷新成功')
        }
        return res
      }).finally(() => {
        this.loading = false
      })
    },

    // 核心处理
    processData() {
      const result = []

      this.rawData.forEach(group => {
        const items = (group.items || []).filter(item => {
          const todayCost = Number(item.todayCashCost) || 0
          const yesterdayCost = Number(item.yesterdayCost) || 0
          return todayCost !== 0 || yesterdayCost !== 0
        })

        // 排序
        items.sort((a, b) => {
          const v1 = a[this.sortKey] || 0
          const v2 = b[this.sortKey] || 0
          return this.sortOrder === 'asc' ? v1 - v2 : v2 - v1
        })

        if (items.length > 0) {
          result.push({
            recordAccount: group.recordAccount,
            items,
            today: group.todayCashCostAll || items.reduce((a, b) => a + (b.todayCashCost || 0), 0),
            yesterday: items.reduce((a, b) => a + (b.yesterdayCost || 0), 0)
          })
        }
      })

      this.groupedList = result
    },

    changeSort(key) {
      if (this.sortKey === key) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc'
      } else {
        this.sortKey = key
        this.sortOrder = 'desc'
      }
      this.processData()
    },

    calc() {
      let t = 0, y = 0
      this.groupedList.forEach(group => {
        t += group.today || 0
        y += group.yesterday || 0
      })
      this.totalCost = t
      this.totalYesterdayCost = y
    },

    // 获取VIVO cookie列表
    fetchVivoCookies(showMessage = true) {
      const axiosInstance = this.$axios || axios
      this.vivoLoading = true
      return axiosInstance.get('https://control.zjwec.cn/api/hdcookie/page', {
        params: {
          pageNum: 1,
          uid: 1,
          role: 1,
          pageSize: 10
        }
      }).then(res => {
        if (res.data.code === "0") {
          this.vivoCookies = res.data.data.records || []
          return this.fetchVivoData(showMessage)
        }
        this.vivoCookies = []
        this.vivoData = []
        this.vivoLoading = false
        return []
      }).catch(err => {
        console.error('获取VIVO cookies失败:', err)
        this.vivoData = []
        this.vivoLoading = false
        this.$message.error('获取VIVO cookies失败')
        return []
      })
    },

    // 查询VIVO数据
    fetchVivoData(showMessage = true) {
      const axiosInstance = this.$axios || axios
      if (!this.vivoCookies || this.vivoCookies.length === 0) {
        this.vivoLoading = false
        return Promise.resolve()
      }

      this.vivoLoading = true
      // 只过滤出深圳和苏州的cookie
      const targetCookies = this.vivoCookies.filter(cookie =>
        cookie.hdname.includes('深圳') || cookie.hdname.includes('苏州') || cookie.hdname.includes('广州力天')
      )

      if (targetCookies.length === 0) {
        this.vivoLoading = false
        this.vivoData = []
        return Promise.resolve()
      }

      const reqs = targetCookies.map(cookie => {
        let region = cookie.hdname
        const todayUrl = 'https://control.zjwec.cn/api/vivo/getToDayData'
        const yesterdayUrl = 'https://control.zjwec.cn/api/vivo/getYesDayData'

        const todayPromise = axiosInstance.post(todayUrl, { cookie: cookie.hdcookie })
          .then(res => {
            if (res.data && res.data.retcode === 0 && res.data.data) {
              return Number(res.data.data.totalConsume) || 0
            }
            return 0
          })
          .catch(err => {
            console.error(`VIVO ${cookie.hdname} 今日数据查询失败:`, err)
            return 0
          })

        const yesterdayPromise = axiosInstance.post(yesterdayUrl, { cookie: cookie.hdcookie })
          .then(res => {
            if (res.data && res.data.retcode === 0 && res.data.data) {
              return Number(res.data.data.totalConsume) || 0
            }
            return 0
          })
          .catch(err => {
            console.error(`VIVO ${cookie.hdname} 昨日数据查询失败:`, err)
            return 0
          })

        return Promise.all([todayPromise, yesterdayPromise]).then(([todayCost, yesterdayCost]) => {
          return {
            advName: `VIVO-${cookie.hdname}`,
            todayCost: todayCost,
            yesterdayCost: yesterdayCost,
            region: region
          }
        })
      })

      return Promise.all(reqs).then(res => {
        this.vivoData = res
        this.calcVivoTotal()
        if (showMessage) {
          this.$message.success('VIVO数据刷新成功')
        }
        return res
      }).finally(() => {
        this.vivoLoading = false
      })
    },

    // 计算VIVO总计
    calcVivoTotal() {
      let todayTotal = 0
      let yesterdayTotal = 0
      this.vivoData.forEach(item => {
        todayTotal += Number(item.todayCost) || 0
        yesterdayTotal += Number(item.yesterdayCost) || 0
      })
      this.vivoTotal = todayTotal
      this.vivoTotalYesterday = yesterdayTotal
    },

    // 查询腾讯数据（新接口一次返回维沃 + 淘宝两主体今日 / 昨日消耗）
    fetchTencentData(showMessage = true) {
      this.tencentLoading = true
      this.tencentError = ''

      return axios.get(TENCENT_QUERY_URL, {
        params: { token: TENCENT_QUERY_TOKEN }
      }).then(res => {
        const data = res.data || {}
        if (data.ok !== true || !data.total || !Array.isArray(data.data)) {
          throw new Error(data.error || '腾讯数据获取失败')
        }
        this.normalizeTencentData(data)
        if (showMessage) {
          this.$message.success('腾讯数据刷新成功')
        }
        return this.tencentData
      }).catch(err => {
        console.error('腾讯数据查询失败:', err)
        // 401 令牌失效 / 500 服务端配置缺失 / 502 上游腾讯接口报错时，error 字段带中文原因
        const msg = err.response && err.response.data && err.response.data.error
        this.tencentError = msg || '腾讯数据加载失败'
        this.$message.error(this.tencentError)
        return []
      }).finally(() => {
        this.tencentLoading = false
      })
    },

    // 标准化新接口返回：total 为两主体合计，data 为逐主体明细（cost 为 double 数值）
    normalizeTencentData(body) {
      const total = body.total || {}
      this.tencentTotal = Number((total.today || {}).cost) || 0
      this.tencentTotalYesterday = Number((total.yesterday || {}).cost) || 0
      this.tencentData = (body.data || []).map(item => ({
        id: item.subject,
        name: item.subject,
        todayCost: Number((item.today || {}).cost) || 0,
        yesterdayCost: Number((item.yesterday || {}).cost) || 0
      }))
    },

    // 查询快手数据（汇总接口）
    fetchKuaishouData(showMessage = true) {
      this.kuaishouLoading = true
      return axios.get('https://wcry.zjwec.cn/ks/report/total').then(res => {
        const data = res.data || {}
        if ((data.code === 200 || data.code === '200') && data.data) {
          this.normalizeKuaishouData(data.data)
          if (showMessage) {
            this.$message.success('快手数据刷新成功')
          }
        } else {
          this.$message.error(data.msg || '快手数据获取失败')
        }
        return this.kuaishouData
      }).catch(err => {
        console.error('快手数据查询失败:', err)
        this.$message.error('快手数据加载失败')
        return []
      }).finally(() => {
        this.kuaishouLoading = false
      })
    },

    // 标准化快手数据（汇总接口，无账户明细）
    normalizeKuaishouData(body) {
      this.kuaishouTotal = Number(body.totalCost) || 0
      this.kuaishouTotalYesterday = Number(body.totalYesterdayCost) || 0
      this.kuaishouData = []
    },

    // 查询趣头条数据（总消耗 + 逐客户明细，接口一次返回；不传 userid 表示全部账户）
    fetchQttData(showMessage = true) {
      this.qttLoading = true
      this.qttError = ''
      return axios.get('https://wcry.zjwec.cn/operation/qtt/report/summary').then(res => {
        const data = res.data || {}
        if ((data.code === 200 || data.code === '200') && data.data) {
          this.normalizeQttData(data.data)
          if (showMessage) {
            this.$message.success('趣头条数据刷新成功')
          }
        } else {
          // 全部客户取数失败时后端直接返回错误，这里必须显式提示，不能显示成 0
          this.qttData = []
          this.qttError = data.msg || '趣头条数据获取失败'
          this.$message.error(this.qttError)
        }
        return this.qttData
      }).catch(err => {
        console.error('趣头条数据查询失败:', err)
        this.qttData = []
        this.qttError = '趣头条数据加载失败'
        this.$message.error('趣头条数据加载失败')
        return []
      }).finally(() => {
        this.qttLoading = false
      })
    },

    // 标准化趣头条数据，失败客户的金额保持 null 不折算为 0
    normalizeQttData(body) {
      this.qttData = (body.customers || []).map(item => ({
        agentName: item.agentName || '',
        customerName: item.customerName,
        todayCost: item.todayCost == null ? null : Number(item.todayCost),
        yesterdayCost: item.yesterdayCost == null ? null : Number(item.yesterdayCost),
        success: item.success !== false,
        errorMsg: item.errorMsg || ''
      }))
      this.qttTotal = Number(body.totalCost) || 0
      this.qttTotalYesterday = Number(body.totalYesterdayCost) || 0
      // 部分客户失败时不再弹提示，改用区块内常驻的 qtt-tip，避免每次刷新都弹一次
      this.qttPartial = body.partial === true
    },

    // 趣头条金额格式化，取数失败显示短横线而非 0.00
    formatQttCost(value) {
      if (value == null) {
        return '-'
      }
      return Number(value).toFixed(2)
    },

    // 查询 WiFi 数据：账号级今日 / 昨日汇总
    fetchWifiData(showMessage = true) {
      this.wifiLoading = true
      this.wifiError = ''
      return axios.post(WIFI_STATIC_URL, {}).then(res => {
        const data = res.data || {}
        if ((data.code === 200 || data.code === '200') && Array.isArray(data.data)) {
          this.normalizeWifiData(data.data)
          if (showMessage) {
            this.$message.success('WiFi数据刷新成功')
          }
        } else {
          this.wifiData = []
          this.wifiError = data.msg || 'WiFi数据获取失败'
          this.$message.error(this.wifiError)
        }
        return this.wifiData
      }).catch(err => {
        console.error('WiFi数据查询失败:', err)
        this.wifiData = []
        this.wifiError = 'WiFi数据加载失败'
        this.$message.error('WiFi数据加载失败')
        return []
      }).finally(() => {
        this.wifiLoading = false
      })
    },

    // 标准化账号汇总，接口金额单位是分，这里统一折算成元；失败账号保持 null 且不计入总额
    normalizeWifiData(list) {
      this.wifiData = (list || []).map(item => ({
        accountId: item.accountId,
        accountName: item.accountName || item.account || `账号${item.accountId}`,
        todayCost: item.spend == null ? null : Number(item.spend) / 100,
        yesterdayCost: item.spendY == null ? null : Number(item.spendY) / 100,
        success: item.success !== false,
        errorMsg: item.error || ''
      }))
      this.wifiTotal = this.wifiData.reduce((sum, item) => sum + (item.success ? (item.todayCost || 0) : 0), 0)
      this.wifiTotalYesterday = this.wifiData.reduce((sum, item) => sum + (item.success ? (item.yesterdayCost || 0) : 0), 0)
      this.wifiPartial = this.wifiData.some(item => item.success === false)
    },

    // WiFi 金额格式化，取数失败显示短横线而非 0.00
    formatWifiCost(value) {
      if (value == null) {
        return '-'
      }
      return Number(value).toFixed(2)
    },

    // 刷新所有数据
    fetchAllData() {
      const isRefresh = this.dataReady
      this.allLoading = true
      if (!this.dataReady) {
        this.pageLoading = true
      }

      const vivoTask = this.vivoCookies && this.vivoCookies.length > 0
        ? this.fetchVivoData(false)
        : this.fetchVivoCookies(false)

      return Promise.all([
        this.fetchData(false).catch(err => {
          console.error('OPPO数据刷新失败:', err)
          this.$message.error('OPPO数据刷新失败')
        }),
        vivoTask.catch(err => {
          console.error('VIVO数据刷新失败:', err)
          this.$message.error('VIVO数据刷新失败')
        }),
        this.fetchTencentData(false),
        this.fetchKuaishouData(false),
        this.fetchQttData(false),
        this.fetchWifiData(false)
      ]).then(() => {
        if (isRefresh) {
          this.$message.success('数据刷新完成')
        }
      }).finally(() => {
        this.allLoading = false
        this.pageLoading = false
        this.dataReady = true
      })
    }
  }
}
</script>

<style scoped>
.container {
  position: relative;
  min-height: 100vh;
  padding: 12px;
  overflow-x: hidden;
  color: #17233d;
  /* 全局 #app 带有 text-align:center（App.vue），会继承到看板所有文本，这里显式重置为左对齐 */
  text-align: left;
  background:
    radial-gradient(circle at 14% 6%, rgba(52, 128, 255, 0.20), transparent 30%),
    radial-gradient(circle at 92% 12%, rgba(98, 168, 255, 0.14), transparent 28%),
    linear-gradient(160deg, #eaf3ff 0%, #f5f9ff 46%, #edf5ff 100%);
}
.container::before {
  content: '';
  position: fixed;
  inset: 0;
  pointer-events: none;
  background-image:
    linear-gradient(rgba(52, 128, 255, 0.08) 1px, transparent 1px),
    linear-gradient(90deg, rgba(52, 128, 255, 0.08) 1px, transparent 1px);
  background-size: 24px 24px;
  mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.55), transparent 82%);
}
.dashboard {
  position: relative;
  z-index: 1;
  max-width: 980px;
  margin: 0 auto;
}
.page-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 14px;
  padding: 16px;
  border: 1px solid rgba(52, 128, 255, 0.20);
  border-radius: 18px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.92), rgba(239, 247, 255, 0.86));
  box-shadow: 0 14px 34px rgba(33, 91, 168, 0.13);
  backdrop-filter: blur(12px);
}
.page-kicker {
  color: #347fff;
  font-size: 11px;
  letter-spacing: 1.8px;
  font-weight: 700;
}
.page-title {
  margin-top: 4px;
  font-size: 22px;
  line-height: 1.2;
  font-weight: 800;
  color: #17233d;
}
.page-desc {
  margin-top: 6px;
  font-size: 12px;
  color: #6b7a90;
}
.refresh-btn {
  flex-shrink: 0;
  border: 0;
  border-radius: 999px;
  background: linear-gradient(135deg, #347fff, #5aa9ff);
  box-shadow: 0 10px 22px rgba(52, 128, 255, 0.22);
}
.refresh-tip {
  position: sticky;
  top: 8px;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-bottom: 10px;
  padding: 9px 12px;
  border: 1px solid rgba(52, 128, 255, 0.18);
  border-radius: 999px;
  color: #2468d9;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 10px 24px rgba(45, 76, 120, 0.12);
  backdrop-filter: blur(10px);
  font-size: 12px;
}

/* 全平台总汇总 */
.total-summary {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
  margin-bottom: 16px;
}
.total-card {
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 18px 20px;
  border-radius: 20px;
  color: #fff;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(45, 76, 120, 0.18);
  transition: all 0.3s ease;
}
.total-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 24px 48px rgba(45, 76, 120, 0.22);
}
.total-card::before {
  content: '';
  position: absolute;
  width: 140px;
  height: 140px;
  right: -40px;
  top: -40px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.12);
}
.total-card::after {
  content: '';
  position: absolute;
  width: 80px;
  height: 80px;
  right: 20px;
  bottom: -20px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.08);
}
.total-today {
  background: linear-gradient(135deg, #1a5fb4, #3574d2, #5a9bff);
}
.total-yesterday {
  background: linear-gradient(135deg, #5a3fbf, #7c5fd4, #a78bfa);
}
.total-icon {
  position: relative;
  z-index: 1;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.2);
  font-size: 20px;
}
.total-content {
  position: relative;
  z-index: 1;
}
.total-label {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.85);
  margin-bottom: 6px;
}
.total-value {
  font-size: 32px;
  font-weight: 900;
  letter-spacing: 0.5px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.total-detail {
  position: relative;
  z-index: 1;
  margin-top: 10px;
  font-size: 11px;
  color: rgba(255, 255, 255, 0.7);
  padding-top: 10px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
}

/* 首屏加载 */
.page-loading {
  position: relative;
  z-index: 1;
  min-height: calc(100vh - 24px);
  display: flex;
  align-items: center;
  justify-content: center;
}
.loader-card {
  width: min(320px, 88vw);
  padding: 30px 22px;
  text-align: center;
  border: 1px solid rgba(52, 128, 255, 0.18);
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 24px 60px rgba(45, 76, 120, 0.16);
  backdrop-filter: blur(14px);
}
.loader-core {
  width: 76px;
  height: 76px;
  margin: 0 auto 18px;
  border-radius: 50%;
  border: 2px solid rgba(52, 128, 255, 0.14);
  border-top-color: #347fff;
  border-right-color: #5aa9ff;
  box-shadow: 0 0 22px rgba(52, 128, 255, 0.22);
  animation: spin 1s linear infinite;
}
.loader-title {
  font-size: 18px;
  font-weight: 800;
  color: #17233d;
}
.loader-subtitle {
  margin-top: 8px;
  font-size: 12px;
  color: #7b8a9d;
}
@keyframes spin {
  to { transform: rotate(360deg); }
}

/* 汇总 */
.summary {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 14px;
}
.summary-row {
  display: contents;
}
.card {
  position: relative;
  min-height: 78px;
  padding: 13px 14px;
  overflow: hidden;
  border-radius: 16px;
  color: #fff;
  box-shadow: 0 14px 30px rgba(45, 76, 120, 0.14);
  transition: all 0.3s ease;
}
.card::after {
  content: '';
  position: absolute;
  width: 90px;
  height: 90px;
  right: -36px;
  top: -34px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.18);
}
.card:hover {
  transform: translateY(-3px);
  box-shadow: 0 18px 36px rgba(45, 76, 120, 0.18);
}
.card.oppo {
  background: linear-gradient(135deg, #00a862, #45c787);
}
.card.oppo-soft {
  background: linear-gradient(135deg, #2fbf7f, #78d8a7);
}
.card.vivo {
  background: linear-gradient(135deg, #347fff, #5aa9ff);
}
.card.vivo-soft {
  background: linear-gradient(135deg, #5a9bff, #86c3ff);
}
.card.tencent {
  background: linear-gradient(135deg, #1677ff, #00a3ff);
}
.card.tencent-soft {
  background: linear-gradient(135deg, #2b8cff, #66c2ff);
}
.card.kuaishou {
  background: linear-gradient(135deg, #ff4906, #ff6b35);
}
.card.kuaishou-soft {
  background: linear-gradient(135deg, #ff6b35, #ff8c66);
}
/* 趣头条品牌色为橙红，与快手撞色，改用紫色系保证六张卡片可区分 */
.card.qtt {
  background: linear-gradient(135deg, #7c4dff, #9c6bff);
}
.card.qtt-soft {
  background: linear-gradient(135deg, #9c6bff, #b794ff);
}
/* WiFi 用青色系，与其余五家区分 */
.card.wifi {
  background: linear-gradient(135deg, #0f9b8e, #2fc4b2);
}
.card.wifi-soft {
  background: linear-gradient(135deg, #2fc4b2, #6fe0d2);
}
.card-label {
  position: relative;
  z-index: 1;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.9);
}
.value {
  position: relative;
  z-index: 1;
  margin-top: 8px;
  font-size: 21px;
  font-weight: 900;
  letter-spacing: 0.2px;
}

/* 表头 */
.header-fixed {
  position: sticky;
  top: 8px;
  z-index: 10;
  margin-bottom: 10px;
  border-radius: 14px;
  border: 1px solid rgba(52, 128, 255, 0.16);
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 10px 24px rgba(45, 76, 120, 0.12);
  backdrop-filter: blur(10px);
}

/* 卡片 */
.card-item {
  position: relative;
  margin-bottom: 12px;
  padding: 12px;
  overflow: hidden;
  border-radius: 18px;
  border: 1px solid rgba(52, 128, 255, 0.14);
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 14px 30px rgba(33, 91, 168, 0.12);
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
}
.card-item::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 2px;
  background: linear-gradient(90deg, transparent, #347fff, #5aa9ff, transparent);
  opacity: 0.58;
}
.oppo-section::before {
  background: linear-gradient(90deg, transparent, #00a862, #45c787, transparent);
}
.vivo-section::before {
  background: linear-gradient(90deg, transparent, #347fff, #5aa9ff, transparent);
}
.tencent-section::before {
  background: linear-gradient(90deg, transparent, #1677ff, #00a3ff, transparent);
}
.kuaishou-section::before {
  background: linear-gradient(90deg, transparent, #ff4906, #ff6b35, transparent);
}
.qtt-section::before {
  background: linear-gradient(90deg, transparent, #7c4dff, #9c6bff, transparent);
}
.wifi-section::before {
  background: linear-gradient(90deg, transparent, #0f9b8e, #2fc4b2, transparent);
}
.card-item:hover {
  border-color: rgba(52, 128, 255, 0.26);
  transform: translateY(-2px);
}

/* 分组头 */
.header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 9px;
}
.title {
  font-weight: 800;
  color: #17233d;
}
.title-sub {
  margin-top: 3px;
  font-size: 11px;
  color: #8795a8;
}
.stats {
  flex-shrink: 0;
  padding: 4px 8px;
  border-radius: 999px;
  font-size: 12px;
  color: #2468d9;
  background: rgba(52, 128, 255, 0.08);
  border: 1px solid rgba(52, 128, 255, 0.14);
}

/* 表格 */
.table {
  width: 100%;
  overflow-x: auto;
  font-size: 12px;
  -webkit-overflow-scrolling: touch;
}
.row {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  align-items: center;
  min-height: 38px;
  padding: 8px 8px;
  border-bottom: 1px solid rgba(45, 76, 120, 0.08);
  color: #40556f;
}
.row:not(.header-row):hover {
  background: rgba(52, 128, 255, 0.05);
}
.vivo-table .row {
  grid-template-columns: 2fr 1fr 1fr 1fr;
}
.tencent-table .row {
  grid-template-columns: 2fr 1fr 1fr;
}
.kuaishou-table .row {
  grid-template-columns: 1fr 3fr 1fr 1fr;
}
.qtt-table .row {
  grid-template-columns: 1fr 2fr 1fr 1fr;
}
.wifi-table .row {
  grid-template-columns: 2fr 1fr 1fr;
}
/* 取数失败的客户行，金额显示短横线并整行弱化 */
.qtt-failed {
  color: #c0362c;
  background: rgba(255, 77, 79, 0.06);
}
.qtt-tip {
  margin-bottom: 8px;
  padding: 6px 10px;
  border-radius: 10px;
  font-size: 12px;
  color: #b26a00;
  background: rgba(250, 173, 20, 0.12);
  border: 1px solid rgba(250, 173, 20, 0.28);
}
.qtt-error {
  margin-top: 8px;
  padding: 6px 10px;
  border-radius: 10px;
  font-size: 12px;
  color: #c0362c;
  background: rgba(255, 77, 79, 0.08);
  border: 1px solid rgba(255, 77, 79, 0.2);
}
/* 取数失败的账号行，金额显示短横线并整行弱化 */
.wifi-failed {
  color: #c0362c;
  background: rgba(255, 77, 79, 0.06);
}
.wifi-tip {
  margin-bottom: 8px;
  padding: 6px 10px;
  border-radius: 10px;
  font-size: 12px;
  color: #b26a00;
  background: rgba(250, 173, 20, 0.12);
  border: 1px solid rgba(250, 173, 20, 0.28);
}
.wifi-error {
  margin-top: 8px;
  padding: 6px 10px;
  border-radius: 10px;
  font-size: 12px;
  color: #c0362c;
  background: rgba(255, 77, 79, 0.08);
  border: 1px solid rgba(255, 77, 79, 0.2);
}
.header-row {
  min-height: 36px;
  border-bottom: 0;
  border-radius: 10px;
  font-weight: 800;
  color: #2468d9;
  background: linear-gradient(135deg, rgba(52, 128, 255, 0.11), rgba(90, 169, 255, 0.08));
}

/* 文本 */
.name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #17233d;
}

/* 预警 */
.warn {
  color: #f56c6c;
  font-weight: bold;
}

/* loading */
.loading {
  margin-bottom: 12px;
  padding: 24px 12px;
  text-align: center;
  border: 1px dashed rgba(64, 158, 255, 0.22);
  border-radius: 16px;
  color: #7b8a9d;
  background: rgba(255, 255, 255, 0.7);
  font-size: 13px;
}

@media (max-width: 768px) {
  .container {
    padding: 10px;
  }
  .page-head {
    padding: 14px;
    border-radius: 16px;
  }
  .page-title {
    font-size: 20px;
  }
  .total-summary {
    gap: 10px;
  }
  .total-card {
    padding: 14px 16px;
    border-radius: 16px;
  }
  .total-value {
    font-size: 24px;
  }
  .summary {
    gap: 10px;
  }
  .card {
    min-height: 72px;
    padding: 12px;
    border-radius: 14px;
  }
  .value {
    font-size: 18px;
  }
  .card-item {
    padding: 10px;
    border-radius: 16px;
  }
  .row {
    padding: 8px 6px;
    font-size: 11px;
  }
}

@media (max-width: 480px) {
  .page-head {
    flex-direction: column;
    align-items: stretch;
  }
  .refresh-btn {
    width: 100%;
  }
  .total-summary {
    grid-template-columns: 1fr;
  }
  .total-value {
    font-size: 26px;
  }
  .summary {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .card-label {
    font-size: 11px;
  }
  .value {
    font-size: 17px;
  }
  .header {
    flex-direction: column;
  }
  .stats {
    align-self: flex-start;
  }
  .row {
    grid-template-columns: 1.8fr 1fr 1fr 1fr;
  }
  .vivo-table .row {
    min-width: 430px;
  }
  .qtt-table .row {
    grid-template-columns: 1fr 1.8fr 1fr 1fr;
    min-width: 430px;
  }
  .tencent-table .row {
    grid-template-columns: 1.8fr 1fr 1fr;
  }
  .kuaishou-table .row {
    grid-template-columns: 0.8fr 2.2fr 1fr 1fr;
    min-width: 480px;
  }
  .header-fixed .row {
    min-width: 430px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/oppo/data/ZhangjieData.vue